import { render, staticRenderFns } from "./ActionPalette.vue?vue&type=template&id=cc24190c&scoped=true"
import script from "./ActionPalette.vue?vue&type=script&lang=js"
export * from "./ActionPalette.vue?vue&type=script&lang=js"
import style0 from "./ActionPalette.vue?vue&type=style&index=0&id=cc24190c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc24190c",
  null
  
)

export default component.exports